import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-1c2c399e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-layout" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "controls" }
const _hoisted_4 = {
  key: 0,
  class: "card flex col"
}
const _hoisted_5 = { class: "f30 text-muted" }
const _hoisted_6 = { style: {"padding":"18px"} }
const _hoisted_7 = { "data-label": "Etablissement" }
const _hoisted_8 = { class: "" }
const _hoisted_9 = { "data-label": "Montant" }
const _hoisted_10 = { class: "text-muted" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavHeader = _resolveComponent("NavHeader")!
  const _component_SeCalendarRanged = _resolveComponent("SeCalendarRanged")!
  const _component_SeDropdownItem = _resolveComponent("SeDropdownItem")!
  const _component_SeDropdown = _resolveComponent("SeDropdown")!
  const _component_SeTable = _resolveComponent("SeTable")!
  const _component_SeExpendable = _resolveComponent("SeExpendable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_NavHeader, {
      title: _ctx.Lang.getI18N('billing')
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_SeCalendarRanged),
        _createVNode(_component_SeDropdown, {
          search: true,
          onSelectionChanged: _ctx.onDistributorChange,
          titleFunc: (distributor) => distributor.name
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.distributors, (distributor) => {
              return (_openBlock(), _createBlock(_component_SeDropdownItem, {
                key: distributor.ref.id,
                value: distributor
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(distributor.name), 1)
                ]),
                _: 2
              }, 1032, ["value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["onSelectionChanged", "titleFunc"])
      ]),
      (_ctx.summary)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, "Total : " + _toDisplayString(_ctx.summary.total) + " €", 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.summary.billedStores.keys(), (key) => {
              return (_openBlock(), _createBlock(_component_SeExpendable, { headerSize: 20 }, {
                header: _withCtx(() => [
                  _createTextVNode(_toDisplayString(key), 1)
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_SeTable, {
                      widths: [50, 50],
                      columns: [_ctx.Lang.getI18N('name'), _ctx.Lang.getI18N('price')]
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.summary.billedStores.get(key), (store) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: store.name
                          }, [
                            _createElementVNode("td", _hoisted_7, [
                              _createElementVNode("span", _hoisted_8, _toDisplayString(store.name), 1)
                            ]),
                            _createElementVNode("td", _hoisted_9, [
                              _createElementVNode("span", _hoisted_10, _toDisplayString(store.cost.toFixed(2)) + "€ ", 1)
                            ])
                          ]))
                        }), 128))
                      ]),
                      _: 2
                    }, 1032, ["columns"])
                  ])
                ]),
                _: 2
              }, 1024))
            }), 256))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}